export const ROUTES = {
  ABOUT: "/about",

  CHANNELS: {
    MAIN: "/listPrograms",
    SINGLE: "/livePlayer/:id",
  },
  CONTACTS: "/contacts",
  DETAIL: {
    ACTORS: "/detail/:id/actors",
    COMMENTS: "/detail/:id/comments",
    RATE: "/detail/:id/rate",
    EPISODE: "/detail/:id/film",
    SERIAL_EPISODE: "/detail/:id/episode/:episodeId",
    EPISODES: "/detail/:id/episodes",
    MAIN: "/detail/:id",
    MORE_COMMENTS: "/detail/:id/more-comments",
    TRAILER: "/detail/:id/trailer/:trailerId",
    TRAILERS: "/detail/:id/trailers",
  },
  ERROR: "/404",
  FAVORITES: "/favorites",
  GATE: {
    MAIN: "/gate",
    PROFILES: "/gate/profiles",
    UPDATE_PROFILE: "/gate/update-profile/:id",
    CREATE_PROFILE: "/gate/create-profile",
  },
  HISTORY: "/history",
  LICENSE: "/license",
  MAIN: {
    CATALOG: "/catalog/:id",
    COLLECTION: "/collection/:id",
    COLLECTIONS: "/collections",
    COUNTRY: "/country/:id",
    DETAIL_PERSON: "/detail/:id",
    DISTRIBUTOR: "/distributor/:id",
    DISTRIBUTOR_GENRE: "/distributor/:id/genre/:genre",
    GENRE: "/genre/:id",
    GENRES: "/genres",
    MAIN: "/",
    PREMIERE: "/premiere",
    YEAR: "/year/:year",
  },
  NOT_FOUND: "*",
  NOTIFICATIONS: {
    MAIN: "/notifications",
    SINGLE: "/notifications/:id",
  },
  PERSONS: {
    MAIN: "/persons",
    SINGLE: "/persons/:id",
  },
  PERSON_DETAILS: "/details-person/:id",
  PRIVACY: "/privacy",
  SEARCH: "/search",
  SEARCH_CONTENT: "/search/content",
  SERVER_ERROR: "/500",
  STAFF: {
    AVAILABLE_SUBSCRIPTIONS: "/staff/available-subscriptions",
    CARDS: "/staff/cards",
    MAIN: "/staff",
    NAVIGATIONS: "/staff/navigations",
    ORDER_MOVIE: "/staff/order-movie",
    PAYMENT_HISTORY: "/staff/payment-history",
    SESSIONS: "/staff/sessions",
    USER_SETTINGS: "/staff/user-settings",
  },
  SUBS: "/subs",
};

const dynamicRoute = (route: string, param_name: string = "id") => {
  route = route.replace(/\/+$/g, "");
  return (param: number | string) => (param == null ? `${route}/${param_name}` : `${route}/${param}`);
};

const routeWithTrailingSlashes = "/example/path///";
const cleanedRoute = dynamicRoute(routeWithTrailingSlashes);
console.log(cleanedRoute(123)); // Output: "/example/path/123"

// ROUTES.STAFF.CARDS.CARD(4656545456).OWNERS.OWNER()
